import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { theme } from 'src/screens/WhiteLabels/Templates/Template1/Template';
import { useMediaQuery } from '@mui/material';

const agentId = process.env.REACT_APP_ELEVENLABS_AGENT_ID;

const ElevenLabsWidget = ({ i18n }) => {
  const isRTL = i18n.translator.language === 'ar';
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  const path = window.location.pathname;
  const shouldHideWidget = path === '/' || path.startsWith('/getstarted');

  useEffect(() => {
    if (shouldHideWidget) return;

    if (!document.getElementById('elevenlabs-widget')) {
      const script = document.createElement('script');
      script.id = 'elevenlabs-widget';
      script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
      script.async = true;
      script.type = 'text/javascript';
      document.body.appendChild(script);
    }
  }, [shouldHideWidget]);

  if (shouldHideWidget) return null;

  return (
    <elevenlabs-convai
      style={matches ? { bottom: '60px' } : {}}
      dir={isRTL ? 'rtl' : 'ltr'}
      agent-id={agentId}
    ></elevenlabs-convai>
  );
};

export default withTranslation('common')(ElevenLabsWidget);